import React from 'react'
import { Text } from '@paypalcorp/pp-react';
import { StyleSheet, css } from 'aphrodite';

import { localsMessages } from '../utility/getTemplateData';
let messages = localsMessages('buttons/partner');

const styles = StyleSheet.create({
	disclaimerWrapper: {
		maxWidth: 350,
		margin: 'auto',
		'.ppvx_accordion__row': { border: 'none' }
	},
	disclaimer: {
		margin: 'auto',
	},
});


export default function VoucherFlowDisclaimer() {
	return (
		<div className={`voucher-disclaimer ${css(styles.disclaimerWrapper)}`}>
            <Text size="sm" style={{
				color: '#687173',
				padding: '0 8px'
			}} dangerouslySetInnerHTML={{
				__html: messages.voucher.legal
			}}></Text>
        </div>
	)
}
